function checkCharacterLimit(text: string): boolean {
  return text.length <= 50;
};

export default checkCharacterLimit
